import Axios from "axios";
import {AxiosProcessor} from "../../shared/axios/AxiosProcessor";
const urlDocument = '/documentRule';
import {DOCUMENT_RULE_TYPES} from '../../shared/enums/DocumentRule'

const state = {
    documentRule: {},
    documentRules: [],
    documentRuleDetails: {},
    documentsPageKey:{}
};

const getters = {
    getDocumentRule: state => {
        return state.documentRule;
    },
    getDocumentRules: state => {
        return state.documentRules;
    },
    getDocumentRuleDetails: state => {
        return state.documentRuleDetails;
    },
    getDocumentsPageKey : state => {
        return state.documentsPageKey;
    }
};

const mutations = {
    setDocumentRule: (state, data) => {
        state.documentRule = data;
    },
    setDocumentRules: (state, data) => {
        state.documentRules = data;
    },
    setDocumentRuleDetails: (state, data) => {
        state.documentRuleDetails = data;
    },
    setDocumentsPageKey: (state, data) => {
        state.documentsPageKey = data;
    }
};

const actions = {
     setDocumentRule: async ({commit}, data) => {
        //going backend
        let value = {};

        if(!!!data.id) {
            value  = await AxiosProcessor.post(urlDocument, data);
        }
        else {
            value = await AxiosProcessor.put(urlDocument+'/'+ data.id, data);
        }

        commit('setDocumentRule', value);
    },
    async getDocumentRule ({commit}, data){
        let id = data.id;

        if (!id)
            throw {message: 'empty id. Please provide a valid id value'};

        /**
         * First we check the state
         * then we check the list
         * then we go to backend
         */
         if(state.documentRule.id && state.documentRule.id === id)
             return;

        let documentRule;
        let value = {};

        if (state.documentRules.length > 0) {
            documentRule  = state.documentRules.find(doc => doc.id === id);
        }

        if(documentRule)
        {
            value = documentRule;
        }
        else
        {
            let response = await AxiosProcessor.get(urlDocument +'/'+id);

            if(response.Item)
                value = response.Item;
        }

        commit('setDocumentRule', value);
    },
    async getDocumentRules ({commit}, data){

         //set default type value
        let type = !data.type ? DOCUMENT_RULE_TYPES.DOCUMENT : data.type;
        delete data.type;

        let value = [];

        //going backend,
        let response = await AxiosProcessor.list(urlDocument+'/types/'+ type, data);

        if(response.Items)
            value = response.Items;

        commit('setDocumentRules', value);
    },
    async getDocumentRuleDetails ({commit}, data){
        //going backend,
        let value = {};
        let response = await AxiosProcessor.get('/counter/documentRule');

        if(response.Item)
            value = response.Item;

        commit('setDocumentRuleDetails', value);
    },
    async deleteDocumentRule ({commit}, data){
        //going backend,
        let value = {};
        value = await AxiosProcessor.delete(urlDocument+'/'+data.id);

        commit('setDocumentRule', value);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}